import { createRoot } from "react-dom/client";
import { PostHogProvider } from "@posthog/react";
import App from "./App.tsx";
import "./index.css";
import { setupGlobalErrorHandlers } from "./lib/errorLogger";
import { validateEnvVars } from "./lib/envCheck";
import { initSentry } from "./lib/sentry";
import { analytics, getPostHog, loadGTM, initBraze, applyStoredConsentBeforeGtmLoad } from "./lib/analytics";
import { optInPostHog } from "./lib/analytics/posthog-init";
import { hasAnalyticsConsent } from "./lib/cookieConsent";

validateEnvVars();
initSentry();
setupGlobalErrorHandlers();

// REK-3389 (Cookie Policy): do NOT initialize PostHog -- and therefore set no
// PostHog cookie / localStorage -- before analytics consent. Returning visitors
// with stored analytics=true init immediately; everyone else is initialized on
// the first analytics grant (banner Accept / Customize, implied analytics-only
// consent on login, or the signup checkbox) via `optInPostHog()`.
// `getPostHog()` returns the (possibly not-yet-initialized) singleton, which
// PostHogProvider and the analytics SDK tolerate until init.
if (hasAnalyticsConsent()) {
  optInPostHog();
}
const posthog = getPostHog();

// Align Consent Mode with any saved banner choice before GTM runs (returning users + tests)
applyStoredConsentBeforeGtmLoad();

// Load GTM container (consent defaults are set in index.html before this runs)
loadGTM();

// Braze is independent of cookie consent — login implies consent to CRM messaging.
// The SDK initializes on every page load; user identification happens in AuthProvider on login.
initBraze();

// Track session start
analytics.trackEvent({
  name: 'session_started',
  properties: {
    browser: navigator.userAgent.includes('Chrome') ? 'Chrome' : navigator.userAgent.includes('Firefox') ? 'Firefox' : 'Other',
    platform: 'web',
  },
});

createRoot(document.getElementById("root")!).render(
  <PostHogProvider client={posthog}>
    <App />
  </PostHogProvider>
);
